var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrevious(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_117170",
    "data-name": "Group 117170",
    transform: "translate(-151 -602)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background_",
    "data-name": "Background ",
    width: 55,
    height: 55,
    rx: 27.5,
    transform: "translate(151 602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9431",
    "data-name": "Group 9431",
    transform: "translate(186 644) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    x2: 14,
    y2: 14.131,
    transform: "translate(0)",
    fill: "none",
    stroke: "#011538",
    strokeLinecap: "square",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    x1: 14,
    y2: 14,
    transform: "translate(0 14)",
    fill: "none",
    stroke: "#011538",
    strokeLinecap: "square",
    strokeWidth: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.d1e39c049fed4ab2cf872dda25a22693.svg";
export { ForwardRef as ReactComponent };